import axios from '../assets/axios.svg';
import bitbucket from '../assets/bitbucket.svg';
import framermotion from '../assets/framermotion.svg';
import git from '../assets/git.svg';
import github from '../assets/github.svg';
import jira from '../assets/jira.svg';
import mongodb from '../assets/mongodb.svg';
import nextjs from '../assets/nextjs.svg';
import npm from '../assets/npm.svg';
import postman from '../assets/postman.svg';
import reactquery from '../assets/reactquery.svg';
import styledcomponents from '../assets/styledcomponents.svg';
import tailwindcss from '../assets/tailwindcss.svg';
import vscode from '../assets/vscode.svg';
const icon = {
	mongodb,
	nextjs,
	tailwindcss,
	styledcomponents,
	jira,
	bitbucket,
	github,
	framermotion,
	postman,
	git,
	vscode,
	npm,
	axios,
	reactquery,
};
export default icon;
